/* eslint-disable import/no-import-module-exports */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
// import Bugsnag from '@bugsnag/js';
// import BugsnagPluginReact from '@bugsnag/plugin-react';
import {
  Authentication,
  // StorageUtil,
} from 'vibeguide';

// import pkg from '../../../../package.json';
import App from './App';

const local = process.env.APP_ENV === 'local';

/**
 * Start Bugsnag Listener
 */
// Bugsnag.start({
//   apiKey: 'b8b4843a00e850e924160decdb804786',
//   appVersion: pkg.version,
//   releaseStage: process.env.APP_ENV,
//   enabledReleaseStages: [
//     'development',
//     'staging',
//     'production',
//   ],
//   plugins: [new BugsnagPluginReact(React)],
//   onError: (event) => {
//     try {
//       const userData = StorageUtil.getLocal('app:user', {});
//       const user = JSON.parse(userData);

//       event.setUser(
//         user._id,
//         user.email,
//         `${user.fname}${user.lname ? ` ${user.lname}` : ''}`,
//       );
//     } catch (err) {
//       event.setUser(
//         '',
//         '',
//         'Unknown',
//       );
//     }
//   },
// });

// const ErrorBoundary = Bugsnag.getPlugin('react');

const renderApp = (Component) => {
  // Wrap react-hot-loader component if local
  const wrapper = local ? (
    <AppContainer>
      <Component />
    </AppContainer>
  ) : (
    <Component />
  );

  ReactDOM.render(
    wrapper,
    document.getElementById('app'),
  );

  // ReactDOM.render(
  //   <ErrorBoundary>
  //     {wrapper}
  //   </ErrorBoundary>,
  //   document.getElementById('app'),
  // );
};

const displayApplication = async () => {
  await Authentication.getUserInfo();

  if (local && module.hot) {
    module.hot.accept();
  }

  renderApp(App);
};

displayApplication();
